<template>
	<div>
		<Login/>

		<el-dialog :title="gameStore.exchangeGame.name+' - 游戏兑换'" width="780px"
		           :visible.sync="exchangeDialogVisible">
			<Exchange page-position="publicPage"/>
		</el-dialog>
	</div>
</template>

<script setup>
import Login from "@/components/Login.vue";
import bus from '@/plugins/bus'
import {ref, onBeforeUnmount} from "vue";
import {useGameStore, useMemberStore, useGlobalStore} from '@/pinia'
import router from "@/router";
import {checkIn} from '@/api/member'
import {Message} from "element-ui";
import Exchange from "@/components/Exchange.vue";
import {getGame} from '@/api/game'
import {getService} from '@/api/member'
import {getSiteSetting} from '@/api/home'


const memberStore = useMemberStore()
const gameStore = useGameStore()
const globalStore = useGlobalStore()

const exchangeDialogVisible = ref(false)

const goUserCenter = () => {
	if (memberStore.loginStatus) {
		router.push({name: "userCenter"}, onComplete => {
		}, onabort => {
		})
	} else {
		bus.emit("login")
	}
}

const goHome = () => {
	router.push({name: "home"}, onComplete => {
	}, onabort => {
	})
}

const goUrl = (obj) => {
	if (obj.login && !memberStore.loginStatus) {
		bus.emit("login")
		return
	}
	window.open(obj.url, "_blank")
}

const goRecharge = () => {
	if (memberStore.loginStatus) {
		router.push({name: "pay"}, onComplete => {
		}, onabort => {
		})
	} else {
		bus.emit("login")
	}
}

const goBusiness = () => {
	router.push({name: "business"}, onComplete => {
	}, onabort => {
	})
}

const doCheckIn = async () => {
	let res = await checkIn()
	if (res.code === 0) {
		Message.success('签到成功！');
		bus.emit("memberInfo")
	} else if (res.status === 401) {
		bus.emit("login")
	}
}

const doGetGameList = async () => {
	let res = await getGame();
	if (res.code === 0) {
		gameStore.gameList = res.data
	}
}

const showExchange = (game) => {
	if (memberStore.loginStatus) {
		gameStore.exchangeGame = game
		exchangeDialogVisible.value = true
	} else {
		bus.emit("login")
	}
}

const closeExchange = () => {
	exchangeDialogVisible.value = false
}

const doGetService = async () => {
	let res = await getService();
	if (res.code === 0) {
		memberStore.service = res.data.url
		memberStore.serviceArr = res.data.serviceArr
	}
}

const doGetSiteSetting = async () => {
	let res = await getSiteSetting();
	if (res.code === 0) {
		globalStore.siteSettings = res.data;
		bus.emit("addAuthorizationBtn")
		bus.emit("siteSettingLoaded")
	}
}


bus.on('goUserCenter', goUserCenter);
bus.on('goHome', goHome);
bus.on('goUrl', goUrl);
bus.on('checkIn', doCheckIn);
bus.on('showExchange', showExchange);
bus.on('closeExchange', closeExchange);
bus.on('getGameList', doGetGameList);
bus.on("getService", doGetService);
bus.on("goRecharge", goRecharge);
bus.on("getSiteSetting", doGetSiteSetting);
bus.on("goBusiness", goBusiness);

onBeforeUnmount(() => {
	bus.off('goUserCenter', goUserCenter);
	bus.off('goHome', goHome);
	bus.off('goUrl', goUrl);
	bus.off('checkIn', doCheckIn);
	bus.off('closeExchange', closeExchange);
	bus.off('getGameList', doGetGameList);
	bus.off("getService", doGetService);
	bus.off("goRecharge", goRecharge);
	bus.off("getSiteSetting", doGetSiteSetting);
	bus.off("goBusiness", goBusiness);
})
</script>